import { Inject, Injectable } from '@angular/core';
import { ENV, IEnvironment } from 'env/config';
import { Service } from '../entity/index';
import { DataService } from '../http/dataService';
import { K2ViewCustomerData } from '../models/k2ViewCustomerData.model';
import { K2ViewInteraction } from '../models/K2ViewInteraction.model';
import { Repository } from './repository';

@Service({
  api: 'addressBasedCustomerData',
  model: K2ViewCustomerData,
})
@Injectable({ providedIn: 'root' })
export class K2ViewCustomerDataService extends Repository<K2ViewCustomerData> {
  constructor(dataService: DataService, @Inject(ENV) env: IEnvironment) {
    super({
      client: dataService,
      url: env.api.backend.k2view.endpoint as string,
    });
  }

  createFromDTO(item): K2ViewCustomerData {
    return item;
  }
}
